// =============================================
// kvAi — paid Claude-backed tag/keyword suggestion (gated server-side)
// =============================================
import { checkApi } from '../db-viewer/data/dataAccess';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
function token(): string | null { return localStorage.getItem('akt_auth_token'); }
async function apiReady(): Promise<boolean> { return !!token() && (await checkApi()); }

/** Whether this user's plan includes AI tagging (drives the button state). */
export async function aiStatus(): Promise<boolean> {
  if (!(await apiReady())) return false;
  try {
    const r = await fetch(`${API_BASE}/kv/ai-status`, { headers: { Authorization: `Bearer ${token()}` } });
    if (!r.ok) return false;
    const j = await r.json();
    return !!j.enabled;
  } catch { return false; }
}

export interface AiSuggestResult { tags: string[]; keywords: string[]; mock?: boolean; }

/** Claude-suggested tags + keywords. Throws Error with .code=403 when not entitled. */
export async function aiSuggest(title: string, text: string): Promise<AiSuggestResult> {
  if (!(await apiReady())) { const e: any = new Error('Sign in to use AI tagging.'); e.code = 401; throw e; }
  const r = await fetch(`${API_BASE}/kv/ai-tags`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
    body: JSON.stringify({ title, text }),
  });
  if (!r.ok) {
    const body = await r.json().catch(() => ({} as any));
    const e: any = new Error(body.message || `AI tagging failed (${r.status})`);
    e.code = r.status;
    throw e;
  }
  return await r.json();
}
